export const HIGH_SCORE_ICON_TEST_ID = "high-score-anomalies-icon";
export const MEDIUM_SCORE_ICON_TEST_ID = "medium-score-anomalies-icon";
export const LOW_SCORE_ICON_TEST_ID = "low-score-anomalies-icon";
